<app-badge [badgeStyle]="badgeStyle" *ngIf="state">{{ state }}</app-badge>
